import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ApplyForShiftParam,
  ShiftApplicationResource,
  shiftApplicationsApplyForShift,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useApplyForShift = (
  options: UseMutationOptions<
    ShiftApplicationResource,
    Error,
    ApplyForShiftParam,
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (shift: ApplyForShiftParam) =>
      extractData(
        shiftApplicationsApplyForShift({
          body: shift,
        })
      ),
    mutationKey: ['shifts', 'applyForShift'],
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['shifts', 'applicationEvents'],
      });
      options.onSuccess?.(...args);
    },
  });
};
